import {Service} from '../../interfaces/core/service';

export class ServiceFactory {
  /**
   *
   */
  public static fromObject(service: any): Service {
    return new class implements Service {
      id: number = service.id;
      level: number = service.level;
      name: string = service.name;
      shortName: string = service.short_name;
      isMedicalCareAllowed: boolean = service.is_medical_care_allowed;
      canTimeTracking: boolean = service.can_time_tracking;
      color: string = service.color;
      isInCarePlan: boolean = service.is_in_care_plan;
    };
  }

  /**
   *
   * @param services
   */
  public static fromArray(services: any[]): Service[] {
    return services.map((service) => {
      return ServiceFactory.fromObject(service);
    });
  }
}
